export const QUERY_KEYS = {
  CASES: 'joblist',
  PINNED_CASES: 'pinnedCases',
  GROUPS: 'groups',
  USERS: 'users',
  SUBGROUP: 'subgroup',
  GROUP_MEMBERS: 'groupMembers',
  OPERATORS: 'operators',
  QUEUES: 'queues',
  QUEUE_LIST: 'queueList',
  QUEUE_STATS: 'queueStats',
  ASSIGNED_QUEUES: 'assignedQueues',
  ORGANIZATION: 'organization',
  CHAT_MESSAGES: 'chatMessages',
  LIVE_UPDATE_GROUPS: 'liveUpdateGroups',
  MESSAGE_TEMPLATES: 'messageTemplates',
  MESSAGE_TEMPLATE_TOKENS: 'messageTemplateTokens',
  AUTO_CLOSE_CONFIG: 'autoCloseConfig',
  USER_PROPERTIES: (userId: string) => ['userProperties', userId] as const,
  QUEUE: (queueId: string) => ['queue', { id: queueId }] as const,
  QUIET_HOURS_TASKS: (jobId: string) => ['quietHoursTasks', jobId] as const,
  CHAT_MEDIA: (chatId: string) => ['chatMedia', chatId] as const,
};

export const BULK_USER_UPLOAD_IN_PROGRESS_TOAST_ID =
  'bulk-user-upload-in-progress';

export const BULK_UPLOAD_STATUS = 'bulk-upload-status';

export const OPERATORS_BULK_UPLOAD_STATUS_QUERY_KEY = [
  QUERY_KEYS.OPERATORS,
  BULK_UPLOAD_STATUS,
] as const;

export const ADMIN_QUERY_KEYS = {
  orgSettings: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'settings', orgId] as const,
  fullOrgData: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'full', orgId] as const,
  lineOfBusiness: (orgId: string, lobId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'lob', orgId, lobId] as const,
  branding: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'branding', orgId] as const,
  orgAutoReply: (orgName: string) =>
    [QUERY_KEYS.ORGANIZATION, 'autoReply', orgName] as const,
  welcomeMessageRuleset: (rulesetType: string, partnerQuery?: string) =>
    ['welcomeMessages', 'ruleset', rulesetType, partnerQuery] as const,
  reassignmentMessageRuleset: (rulesetType: string, partnerQuery?: string) =>
    ['reassignmentMessages', 'ruleset', rulesetType, partnerQuery] as const,
  assignmentMessageRuleset: (rulesetType: string, partnerQuery?: string) =>
    ['assignmentMessages', 'ruleset', rulesetType, partnerQuery] as const,
  mptMessageRuleset: (partnerQuery?: string) =>
    ['mptMessages', 'ruleset', 'MULTIPARTY_RULESET', partnerQuery] as const,
  lockedOutMessageRuleset: (partnerQuery?: string) =>
    ['lockedOutMessages', 'ruleset', partnerQuery] as const,
  invalidOptInMessageRuleset: (partnerQuery?: string) =>
    ['invalidOptInMessages', 'ruleset', partnerQuery] as const,
  organizationFeatures: (scope = 'public') =>
    [QUERY_KEYS.ORGANIZATION, 'features', scope] as const,
  // Effective gating map. Kept under the `features` prefix so a feature toggle's
  // invalidation (`[ORGANIZATION, 'features']`) also refreshes it.
  effectiveFeatures: () =>
    [QUERY_KEYS.ORGANIZATION, 'features', 'effective'] as const,
  mtlsCertificates: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'mtls', 'certificates', orgId] as const,
  oauth2Clients: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'oauth2', 'clients', orgId] as const,
  oauth2Client: (orgId: string, clientId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'oauth2', 'client', orgId, clientId] as const,
  authStatus: (orgId: string) =>
    [QUERY_KEYS.ORGANIZATION, 'auth', 'status', orgId] as const,
  organizationEntitlements: () =>
    [QUERY_KEYS.ORGANIZATION, 'entitlements'] as const,
  fabricAgents: () => ['fabricAgents'] as const,
  invalidOptInTemplate: () =>
    [QUERY_KEYS.MESSAGE_TEMPLATES, 'invalidOptInResponse'] as const,
  autoCloseConfigs: (partnerQuery?: string) =>
    partnerQuery !== undefined
      ? ([QUERY_KEYS.AUTO_CLOSE_CONFIG, partnerQuery] as const)
      : ([QUERY_KEYS.AUTO_CLOSE_CONFIG] as const),
};
